import React, { useEffect, useState, useContext } from 'react';
import { Box, Typography, CircularProgress, Button } from '@mui/material';
import { AuthContext } from '../components/Auth';
import { httpsCallable } from 'firebase/functions';

const XCallback = () => {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const { functionsInstance } = useContext(AuthContext) || {};

  useEffect(() => {
    const handle = async () => {
      if (!functionsInstance) {
        setMessage('Waiting for functions to initialize...');
        return;
      }
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');

        if (!code) {
          setError('Missing authorization code in the redirect.');
          setLoading(false);
          return;
        }

        const storedState = sessionStorage.getItem('x_oauth_state');
        if (!storedState || storedState !== state) {
          setError('OAuth state mismatch. Possible CSRF.');
          setLoading(false);
          return;
        }

        const codeVerifier = sessionStorage.getItem('x_oauth_code_verifier');
        if (!codeVerifier) {
          setError('Missing PKCE code verifier. Cannot continue.');
          setLoading(false);
          return;
        }


        setMessage('Exchanging authorization code...');

        const xExchange = httpsCallable(functionsInstance, 'xExchange');
        const result = await xExchange({ code, code_verifier: codeVerifier, redirect_uri: window.location.origin + '/x' });
        const data = result.data;

        // Clear stored PKCE items
        sessionStorage.removeItem('x_oauth_code_verifier');
        sessionStorage.removeItem('x_oauth_state');

        setMessage('Connected successfully.');
        console.log('OAuth exchange result:', data);
        try {
          sessionStorage.setItem('x_oauth_result', JSON.stringify(data));
        } catch (e) {
          console.warn('Unable to persist x oauth result', e);
        }
        // Auto-redirect to dashboard so user can see connection info
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 700);
      } catch (e) {
        console.error(e);
        setError(e.message || String(e));
      } finally {
        setLoading(false);
      }
    };

    handle();
  }, [functionsInstance]);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>X OAuth Callback</Typography>
      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <CircularProgress />
          <Typography>{message || 'Processing...'}</Typography>
        </Box>
      ) : error ? (
        <Box>
          <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
          <Button variant="contained" href="/onboarding">Return to onboarding</Button>
        </Box>
      ) : (
        <Box>
          <Typography sx={{ mb: 2 }}>{message || 'Done'}</Typography>
          <Button variant="contained" href="/dashboard">Go to dashboard</Button>
        </Box>
      )}
    </Box>
  );
};

export default XCallback;
